import React from "react";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
import Renato from "@/images/RenP.png";
import running from "@/images/gifs/mm-running.gif";
import finished from "@/images/gifs/mm-finished.gif";
import { Icons } from "@/assets/icons";
import { useLanguage } from "../contexts/LanguageContext";
import { getTranslation } from "../translations/translations";

function Section({ leftBtnText, rightBtnText }) {
  const { language } = useLanguage();
  const activateFinished = () => {
    let run = document.querySelector(".run");
    let done = document.querySelector(".done");
    run.style.display = "none";
    done.style.display = "flex";
  };

  const activateRunning = () => {
    let run = document.querySelector(".run");
    let done = document.querySelector(".done");
    run.style.display = "flex";
    done.style.display = "none";
  };

  return (
    <Wrap>
      <ItemText>
        <h1>{getTranslation(language, "aboutMe.title")}</h1>
        <RightIcons>
          <a href="https://github.com/netsujr" target="_blank" rel="noreferrer">
            <img src={Icons.github} alt="Github" />
          </a>
          <a
            href="https://www.linkedin.com/in/delbonirenato/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Icons.linkedin} alt="Linkedin" />
          </a>
        </RightIcons>
      </ItemText>
      <AboutMeContainer>
        <Fade top>
          <InfoContainer>
            <p>
              {getTranslation(language, "aboutMe.paragraph1")}
              <br />
              <br />
              {getTranslation(language, "aboutMe.paragraph2")}{" "}
              <strong>
                <a href="https://www.kammeko.com/" target="_blank" rel="noreferrer">
                  {getTranslation(language, "aboutMe.kammekoLink")}
                </a>
              </strong>{" "}
              {getTranslation(language, "aboutMe.paragraph2AfterKammeko")}{" "}
              <strong>
                <a href="https://www.hivelocity.co.jp/" target="_blank" rel="noreferrer">
                  {getTranslation(language, "aboutMe.hivelocityLink")}
                </a>
              </strong>{" "}
              {getTranslation(language, "aboutMe.paragraph2AfterHivelocity")}{" "}
              <strong>
                <a href="https://cesanta.com/" target="_blank" rel="noreferrer">
                  {getTranslation(language, "aboutMe.cesantaLink")}
                </a>
              </strong>{" "}
              {getTranslation(language, "aboutMe.paragraph2AfterCesanta")}{" "}
              <strong>
                <a href="https://www.joinreva.com/" target="_blank" rel="noreferrer">
                  {getTranslation(language, "aboutMe.revaLink")}
                </a>
              </strong>{" "}
              {getTranslation(language, "aboutMe.paragraph2Final")}
              <br />
              <br />
              {getTranslation(language, "aboutMe.paragraph3")}
              <br />
              <br />
              {getTranslation(language, "aboutMe.signature")}
            </p>
          </InfoContainer>
        </Fade>
        <Fade bottom>
          <ImgContainer>
            <img src={Renato} alt="RenatoProfile" />
          </ImgContainer>
        </Fade>
      </AboutMeContainer>
      <GifContainer>
        <Running>
          <img
            className="run"
            src={running}
            alt="Megaman-Running"
            onClick={activateFinished}
          />
        </Running>
        <Finished>
          <img
            className="done"
            src={finished}
            alt="Megaman-Finsihed"
            onClick={activateRunning}
          />
        </Finished>
      </GifContainer>
      <Buttons>
        <ButtonGroup>
          <LeftButton>{leftBtnText}</LeftButton>
          {rightBtnText && <RightButton>{rightBtnText}</RightButton>}
        </ButtonGroup>
      </Buttons>
    </Wrap>
  );
}

export default Section;

const Wrap = styled.div`
  max-width: 100vw;
  min-height: 100vh;
  background-color: rgba(248, 241, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const ItemText = styled.div`
  width: 100vw;
  padding-top: 12vh;
  justify-content: center;
  text-align: center;
  color: black;
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }

  h1 {
    margin-top: -7px;
    margin-right: 2px;
    @media (max-width: 768px) {
      font-size: 24px;
      margin-top: -4px;
    }
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  margin: 15px 10px;
  cursor: pointer;
`;

const LeftButton = styled.div`
  background-color: rgba(9, 21, 64, 0.8);
  height: 40px;
  width: 256px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  opacity: 0.85;
  text-transform: uppercase;
  font-size: 12px;
  margin: 8px;
  transition: all 250ms ease;

  & a {
    color: white;
    text-decoration: none;
  }

  &:hover {
    background-color: rgba(9, 21, 64, 0.9);
  }
`;

const RightButton = styled(LeftButton)``;

const Buttons = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  background: rgba(48, 197, 255, 0.4);
  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 20px;
  }
`;

const AboutMeContainer = styled.div`
  flex: 1;
  width: 100vw;
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }
`;

const ImgContainer = styled.div`
  width: 35vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;

  img {
    border-radius: 20px;
    box-shadow: 2px 2px 10px 1px;
    margin-bottom: 40px;
    width: 65%;
  }
`;

const InfoContainer = styled.div`
  width: 65vw;
  height: 100%;
  display: flex;
  padding: 30px;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 90vw;
  }

  p {
    text-align: justify;
    font-size: 16px;
    padding: 20px;
  }
`;

const GifContainer = styled.div`
  display: flex;
  width: 100vw;
  max-height: 50px;
  justify-content: center;
  margin-top: -22px;
`;

const Running = styled.div`
  img {
    max-height: 50px;
    cursor: pointer;
    z-index: 1;
  }
`;

const Finished = styled.div`
  img {
    max-height: 50px;
    cursor: pointer;
    display: none;
    z-index: 1;
  }
`;

const RightIcons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3px;

  img {
    height: 30px;
    padding: 2px;
    margin: 0px 2px;

    &:hover {
      height: 32px;
    }
  }
`;
